export async function getProductHtml(product_id) {

    const formData = new FormData();

    formData.append('action', 'wpvqv_quick_view');
    formData.append('product_id', product_id);
    formData.append('wpvcp_security', wpvqv.security);

    const response = await fetch(wpvqv.ajaxurl, {
        method: 'POST',
        body: formData
    });
    const data = await response.text();
    return data;

}
    